define('modules/yotta',['require','exports','module','app','syze','skrollrCss','skrollr','modules/media/pusher'],function(require, exports, module) {
	"use strict";

	var app = require("app");
	var Syze = require("syze");
	var SkrollrCss = require("skrollrCss");
	var Skrollr = require("skrollr");
	var Media = require("modules/media/pusher");

	var Yotta = Backbone.View.extend({

		name : 'yotta',

		events : {
			//"click label": "addFilter",
			//"click input:checkbox": "addFilter"
		},
		makeActive : function() {

			//this.$el.addClass("active");
		},

		reinit : function() {

		},

		render : function() {

			this.skrollr = Skrollr.init(this.config);
			//var refresher = this.skrollr.refresh;

			//////console.log ('Yotta render' ,this.config.initialSlide ,this.config.initialElem );

			if (!_.isUndefined(this.config.initialElem)) {

				//console.log ('Yotta moved' );

				//this.moveTo();

				this.re_Init(this.config.initialElem);

				////console.log ('Yotta moved' );

			}

			Media.resizeWin();

		

		},

		elements : {

			debug : document.getElementById('debug')

		},

		config : {

			forceHeight : false,

			//edgeStrategy:'reset',

			keyframe : function(element, name, direction) {

				//console.log ("KEY-->", name, direction, element.getAttribute('data-parent'));

				var id = element.getAttribute('data-parent');
				if (_.isNull(id)) {

					id = element.parentNode.id;

				}

		
				Media.get_media_by_keyframe(name, id, direction);

			}
		},

		moveTo : function(el) {
			this.skrollr.off('keyframe');
			if (!_.isUndefined(app.oldHash)) {

				Media.unload_media(document.getElementById(app.oldHash));
			}

			this.re_Init(el);

		},

		re_Init : function(opt) {

			app.oldHash = opt;

			var elm = document.getElementById(opt);
			if (_.isNull(elm)) {

				opt = _.keys(modules_cfg)[0];
				elm = document.getElementById(opt);
				console.log(' MODULO ', ", non trovato, redirect al primo modulo");
			}

			app.router.navigate("s/" + opt);

			Media.set_navigator(Media.NametoInt(opt));

			var listener = this.KeyFrame;
			//this.config.keyframe;
			var offset = this.skrollr.relativeToAbsolute(elm, 'top', 'top');
			return this.skrollr.animateTo(offset + 5, {
				done : function(e) {
					//console.info('MOVED ', opt, app.oldHash,listener);
					Media.get_media_by_id(elm);
					this.on("keyframe", listener);
					//this.trigger("keyframe")
				}
			});

		},

		initialize : function(opt) {

			//$("#s_wrapper").append($(".swiper-slide").get().reverse());
			this.KeyFrame = (this.config.keyframe);

			if (!_.isUndefined(opt) && !_.isNull(opt.hash)) {

				//var n = (this.NametoInt(opt.hash) - 1);

				//	this.config.initialSlide = n;
				this.config.initialElem = opt.hash;
				Media.isforced = opt.hash;
				delete this.config.keyframe;
				//console.log ("Key",this.KeyFrame ,this.config.keyframe );
				//Media.set_navigator(n);
			}

			this.counter = _.size(modules_cfg);

			this.addCss();
			//this.elements.master.className = "skrollr-body";

			this.render();
			//this.elements = {};
		},

		addCss : function() {

			var res = Media.get_media_res();
			if (app.mediatype !== "default") {
				res = app.mediatype;
			}

			var ori = Media.get_orientation();

			var zi = 1000;
			var contator = 0;

			return _.map(modules_cfg, function(e, i) {

				if ("imgs" in e.contents) {

					if (e.type !== "cover_full") {
						if (ori === 'port') {
							ori = "land";

						}

					}

					//////console.log ("====", e.id, e.contents)
					document.getElementById(i).querySelectorAll('.is_shim')[0].src = e.contents.imgs[ori][res];

				}

				if (e.contents.type === "animate") {

					Media.get_media_by_id(document.getElementById(i));

				}

				return _.map(e.properties.CSS_default, function(css, selector) {

					var series;

					//selector!='self'  ?document.getElementById(i).getElementsByClassName(selector) : document.getElementById(i) ;

					//////console.log (series);

					if (selector === 'self') {

						series = document.getElementById(i);

						series.style.zIndex = zi--;

						return series.className += " " + css;

					} else {

						series = document.getElementById(i).getElementsByClassName(selector);

						return _.each(series, function(htmlel) {
							htmlel.style.zIndex = zi--;

							return htmlel.className += " " + css;

						});

					}

				});

			});

		}
	});

	module.exports = Yotta;
});

